<template>
  <!-- 评估详情 -->
  <div>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="评估详情"
      :visible.sync="dialogVisible"
      width="85%"
      :append-to-body="true"
    >
      <div class="wrapper">
        <div class="three" style="padding-bottom: 28px;">
          <div class="reviewStatus">
            审核详情
            <div class="customBtn">
              <button class="custom-button" @click="handleFeedbackRecord">
                <i class="el-icon-chat-line-round"></i> 反馈记录
              </button>
              <button class="custom-button" @click="handleApplyFeedback">
                <i class="el-icon-chat-line-round"></i> 申请反馈
              </button>
              <!-- <button class="custom-button" @click="handleDownloadReport">
                <i class="el-icon-download"></i> 下载评价报告
              </button> -->
            </div>
          </div>
          <div class="detailContent">
            <div class="detailContentTop">
              <div class="left">
                <p class="leftTop">高风险</p>
                <p class="leftBottom">低风险</p>
              </div>
              <div class="center">
                <div class="sanjiao">
                  <div
                    :class="
                      reviewDetail.riskLevel == '1'
                        ? 'sanjiao1 sanjiaoTop'
                        : 'sanjiao1'
                    "
                  ></div>
                  <div
                    :class="
                      reviewDetail.riskLevel == '2'
                        ? 'sanjiao2 sanjiaoCenter'
                        : 'sanjiao2'
                    "
                  ></div>
                  <div
                    :class="
                      reviewDetail.riskLevel == '3'
                        ? 'sanjiao3 sanjiaoBottom'
                        : 'sanjiao3'
                    "
                  ></div>
                </div>
              </div>
              <div class="right">
                <p class="rightTop" :style="setColor" v-if="reviewDetail.score">
                  {{ reviewDetail.riskLevelName }} {{ reviewDetail.score }}分
                </p>
                <p class="rightTop" v-else>暂无数据</p>
                <p class="rightCenter" v-if="reviewDetail.resultRuleStr">
                  ·{{ reviewDetail.resultRuleStr }}
                </p>
                <p class="rightBottom">
                  ·风险等级评分为:低风险、中风险、高风险
                </p>
              </div>
            </div>
            <div class="detailContentTable">
              <div class="ccui-multifunctional-table-wrapper">
                <el-table
                  :data="tableData"
                  :fit="true"
                  border
                  class="ccui-multifunctional-table"
                  :header-cell-style="{ backgroundColor: '#EFF3FA' }"
                >
                  <template v-for="(table, index) in dataJs.ipAlertList">
                    <el-table-column
                      :fixed="table.fixed || false"
                      :key="index"
                      :type="table.type"
                      :label="table.label"
                      :min-width="table.width"
                      :prop="table.prop"
                      :align="table.align || 'left'"
                      :header-align="table.headerAlign || 'left'"
                      :filters="table.filters"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                  </template>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 反馈记录 -->
      <feedbackManagement
        ref="feedbackManagement"
        :reviewId="reviewDetail.applyCode"
        :supCode="supCode"
      />
      <!-- 申请反馈 -->
      <AppealFeedbackDialog
        ref="appealFeedbackDialog"
        :reviewId="reviewDetail.applyCode"
        :supCode="supCode"
      />
    </el-dialog>
  </div>
</template>

<script>
import { qrySupReviewDetail } from "../api";
import dataJs from "../js";
import feedbackManagement from "./feedbackManagement.vue";
import AppealFeedbackDialog from "./appealFeedbackDialog.vue";
import Cookies from "js-cookie";
export default {
  name: "appealFeedbackDialog",
  components: {
    feedbackManagement,
    AppealFeedbackDialog
  },
  props: {},
  computed: {
    setColor() {
      let color = "";
      switch (this.reviewDetail?.riskLevel) {
        case "1":
          color = "#eb4948";
          break;
        case "2":
          color = "#F8A03F";
          break;
        case "3":
          color = "#19bc6b";
          break;
      }
      return `color: ${color}`;
    }
  },
  data() {
    return {
      dataJs,
      dialogVisible: false,
      reviewDetail: {},
      detailBo: {},
      tableData: [],
      supCode: Cookies.get("sup_code") || this.$route.query.supCode
    };
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        if (newVal) {
          this.getDetail();
        }
      }
    }
  },
  activated() {},
  methods: {
    getDetail() {
      let obj = {
        supCode: this.supCode,
        isShowLoading: true
      };
      qrySupReviewDetail(obj).then(res => {
        this.reviewDetail = res.data.data.reviewDetail || {};
        this.detailBo = res.data.data || {};
        if (this.reviewDetail.quotaList?.length) {
          this.tableData = this.reviewDetail.quotaList;
        }
      });
    },
    // 反馈记录
    handleFeedbackRecord() {
      this.$refs["feedbackManagement"].dialogVisible = true;
    },
    // 申请反馈
    handleApplyFeedback() {
      this.$refs["appealFeedbackDialog"].dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
// 审核详情
.reviewStatus {
  position: relative;
  margin-top: 16px;
  padding-left: 10px;
  height: 25px;
  line-height: 25px;
  border-left: 4px solid #3860f4;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #4a4a4a;
  text-align: left;
  font-style: normal;
}

.detailContentTop {
  margin-top: 8px;
  margin-left: 19px;
  display: flex;
  height: 235px;
  background: #fafcff;
}
.left {
  position: relative;
  margin: 13px 164px 22px 23px;
  width: 12px;
  height: 200px;
  background: linear-gradient(180deg, #eb4948 0%, #ffc93e 48%, #19bc6b 100%);
  border-radius: 6px;
}
.leftTop {
  position: absolute;
  top: 0;
  left: 18px;
  width: 36px;
  height: 17px;
  font-family: PingFangTC, PingFangTC;
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.leftBottom {
  position: absolute;
  bottom: 0;
  left: 18px;
  width: 36px;
  height: 17px;
  font-family: PingFangTC, PingFangTC;
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.center {
  margin-top: 13px;
  margin-right: 115px;
  width: 200px;
  height: 200px;
  text-align: center;
}
.sanjiao {
  position: relative;
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 200px solid #fafcff; /* 这里的颜色可根据图片调整为对应的灰色 */
  // #FAFCFF
}
.sanjiao1 {
  // margin: 0 auto;
  // width: 38px;
  // height: 38px;
  // margin-left: 81px;
  // background: #E5E5E5;
  position: absolute;
  top: 0;
  left: -32px;
  width: 0;
  height: 0;
  border-left: 32px solid transparent;
  border-right: 32px solid transparent;
  border-bottom: 62px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}

.sanjiao2 {
  // margin: 10px auto;
  // width: 79px;
  // height: 36px;
  // margin: 5px 0 0 61px;

  position: absolute;
  top: 82px;
  left: -64px;
  width: 84px;
  height: 0;
  border-left: 22px solid transparent;
  border-right: 22px solid transparent;
  border-bottom: 44px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}

.sanjiao3 {
  // margin: 0 auto;
  // width: 120px;
  // height: 36px;
  // margin: 5px 0 0 40px;

  position: absolute;
  top: 146px;
  left: -101px;
  width: 148px;
  height: 0;
  border-left: 27px solid transparent;
  border-right: 27px solid transparent;
  border-bottom: 54px solid #e5e5e5; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.sanjiaoTop {
  border-bottom: 62px solid #eb4948; /* 这里的颜色可根据图片调整为对应的颜色 */
}
.sanjiaoCenter {
  border-bottom: 44px solid #f8c83f; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.sanjiaoBottom {
  border-bottom: 54px solid #19bc6b; /* 这里的颜色可根据图片调整为对应的灰色 */
}
.right {
  width: 552px;
}
.rightTop {
  margin-top: 22px;
  margin-bottom: 16px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.rightCenter {
  margin-bottom: 10px;
  width: 552px;
  height: 44px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.rightBottom {
  width: 488px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
// 审核详情-table
.detailContentTable {
  margin-top: 10px;
  margin-left: 19px;
  padding-right: 110px;
}
.customBtn {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
}
.custom-button {
  width: 100px;
  height: 28px;
  background: linear-gradient(180deg, #6b98ff 0%, #4672ff 100%);
  border-radius: 4px;
  // background-color: #409eff;
  // color: white;
  // border: none;
  // padding: 8px 16px;
  // border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
  font-family: PingFangTC, PingFangTC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: none;
  line-height: 28px;
}
// .custom-button:nth-last-child(1) {
//   width: 126px;
// }
</style>
